<template>
  <div>

        <div class="banner-wrap">
          <section class="banners">
            <img src="../assets/img/about/contact_banner.png" alt="联系我们" />
            <div class="mask-wrap"></div>
          </section>
        </div>
        <div class="container">
          <div class="content-hd">
            <h4>联系我们</h4>
            <p>大吕网络关心每一位用户与合作伙伴的声音！</p>
          </div>
          <!-- 请留下您的联系方式，我们将马上和您联系 -->
          <section class="contact">

            <p><span class="red_icon">* </span>为必填项目，大吕网络科技有限公司深知您的隐私对您的重要性，我们会充分尊重您的隐私。本网站不会出于任何目的访问透露您的内容数据</p>
            <van-form @submit="onSubmit">
              <van-cell-group>
                <van-field
                readonly
                clickable
                :value="formData.business"
                name="咨询业务"
                label="咨询业务"
                right-icon="arrow"
                input-align="left"
                @change="isNull"
                :error-message="errMsg.business"
                placeholder="请选择您想咨询的业务类别"
                :rules="[{ required: true, message: '请选择您想咨询的业务类别' }]"
                @click="businessPicker = true"
                />

              </van-cell-group>
              <van-cell-group style="width:100%">
                <van-field
                  v-model="formData.remark"
                  rows="2"
                  autosize
                  label="具体需求"
                  type="textarea"
                  @blur="checkRemark"
                  :error-message="errMsg.remark"
                  maxlength="50"
                  placeholder="写明您的具体需求，以便我们安排相应顾问与您联系！"
                  show-word-limit
                />
              </van-cell-group>
              <van-cell-group>
                <van-field
                  v-model="formData.phone"
                  type="tel"
                  autosize
                  label="联系电话"
                  placeholder="请留下您的手机号"
                  @blur="checkPhone"
                  :error-message="errMsg.phone"
                  :rules="[{ required: true } , { pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: '请填写联系电话'}]"
                />
              </van-cell-group>
              <div class="btn">
                <van-button type="info" color="rgb(178,16,16)" :disabled="opacitybtn == 'opacitybtn_3' ? true : false " :class="opacitybtn" block native-type="submit">提 交</van-button>
              </div>


            </van-form>
            <van-popup v-model="businessPicker" round position="bottom">
              <van-picker show-toolbar :columns="columns" @cancel="businessPicker = false"
                  @confirm="businessOK" />
            </van-popup>
            <van-dialog v-model="show" confirm-button-text="确定" @confirm="backUp">
                <template #title>
                    <img class="dialog_title" src="../assets/img/word_has.png" alt="">
                    <van-icon class="dialog_icon" name="cross" @click="backUp" />
                </template>
                <h5>简历投递成功</h5>
                <p class="dialog_content">如果您的简历符合我们的岗位要求，我们会尽快联系您来我司进行面试，请静候佳音。</p>
            </van-dialog>
          </section>

        </div>
  </div>
</template>

<script>

export default {
  name:'contact',
  data(){
    return{
      pages:"7",
      bannerUrl:null,

      columns: ["数字营销", "数字内容", "移动游戏", "其他"],
      formData:{
        phone:null,
        remark:null,
        business:null,
      },
      show:false,
      isClick:false,
      businessPicker:false,
      isTrue:false,
      errMsg:{
        phone:'',
        remark:'',
        business:''
      }
    }
  },
    created:function(){
    // axios.post("/banners/" + this.pages).then(function(res) {
    //   vm.bannerUrl = res.data.banners[0].imgurl;
    // }).catch(error => {
    //   console.log(error);
    // })
  },
  computed: {
        opacitybtn: function() {
            let isEmpty = false;
            for (let data in this.formData) {
                if (this.formData[data] === "") {
                    isEmpty = true
                }
            }
            return isEmpty ? "opacitybtn_3" : "opacitybtn_10"
        },
    },
  methods: {
    onSubmit(value) {
      const that = this;
      if( !that.isTrue ){
        return;
      }
      this.$ajax.post("/contactus",that.formData)
      .then(function(response) {
        that.show = true;
      }).catch(function(error) {
          console.log(error)
      })
    },
    checkPhone(){
      if( /^1(3|4|5|6|7|8|9)\d{9}$/.test(this.formData.phone)){
        this.errMsg.phone="";
        this.isTrue = true;
        return;
      }else{
        this.errMsg.phone="请填写正确的联系电话";
        this.isTrue = false;
        return;
      }
    },
    isNull(){
      if(this.formData.business == "" || this.formData.business == null){
        this.errMsg.business="请选择咨询的业务";
        this.isTrue = false;
        return;
      }else{
        this.errMsg.business="";
        this.isTrue = true;
        return;
      }
    },
    checkRemark(){
      if(this.formData.remark == "" || this.formData.remark == null){
        this.errMsg.remark="请填写具体的需求";
        this.isTrue = false;
        return;
      }else{
        this.errMsg.remark="";
        this.isTrue = true;
        return;
      }
    },
    businessOK: function(val) {
      this.formData.business = val;
      this.businessPicker = false;
    },
    backUp() {
      this.$router.push("/");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/global";
@import "../assets/css/function";


.container{
  >.content-hd{
    color: #fff;
    position: relative;
    top: -170px;
    margin: 0 auto;
    >h4{
      color: #fff;
      letter-spacing: 2px;
      font-size: 1.4rem;
      line-height: 2em;
    }
    > p {
      font-size: 1rem;
      letter-spacing: 1px;
    }
  }
}

// 请留下您的联系方式，我们将马上和您联系
.contact {
  padding: 1rem;
  background-color: #fff;
  position: relative;
  top: -10rem;
  box-shadow: 0px 0px 5px rgba(0,0,0,.06);
  >p{
    margin-bottom: 1rem;
  }
  .red_icon{
    color: red;
    text-align: center;
    width: 1rem;
    font-family: "宋体";
    font-size: .8rem;
  }
  .btn{
    margin-top: 20px;
    >button{
      border-radius: 10px;
    }
  }
}

.dialog_title {
  height: 2rem;
  width: 1.88rem;
  position: absolute;
  top: -1rem;
  left: 45%;
  z-index: 2002;
}

.dialog_icon {
  position: absolute;
  top: 7%;
  left: 90%;
  font-weight: bold
}
</style>



// WEBPACK FOOTER //
// src/page/contact.vue